import * as Sentry from '@sentry/vue'

import { BrowserTracing } from '@sentry/tracing'
import { getValidUrl } from '../util/helper'

const twilioIgnores = [`Cannot read properties of undefined (reading 'includes')`]
const firebaseIgnores = [`FirebaseError`]
const ignoredErrorStrings = [
  'user_not_logged_in',
  '.remoteConfig.getString',
  'ConnectionError',
  'UnknownError',
  'has already been declared',
  'last_message_date',
  'ResizeObserver',
  'Cannot read properties of',
  'undefined has no properties',
  'Non-Error promise rejection captured',
  'Network Error',
  ...twilioIgnores,
  ...firebaseIgnores]

/**
 * We filter all the invalid errors here
 * Cases
 *  - when the user is not logged in, we should not capture the error on the login screen.
 *  - Ideally these should be handled on the respective logics, this change is complimentary till then
 * @param event 
 * @param hint 
 * @returns Boolean
 * 
 * FALLBACK if the sentry ignore is invalidated these
 */

const isInvalidError = (hint: Sentry.EventHint, event: Sentry.Event,) => {
  // const { request } = event
  // const originUrl = getValidUrl(request?.url) // fallback to avoid the URL exception
  // const urlDetails = new URL(originUrl)
  if (hint.originalException) {
    const transformedHint = hint.originalException?.toString()?.toLowerCase()
    const isFilteredError = ignoredErrorStrings.some(e => transformedHint.includes(e.toLowerCase()))

    if (isFilteredError) {
      return true
    }

  }

  return false
}

export const setupSentry = (Vue: any, router: any, config: any) => {
  Sentry.init({
    Vue,
    dsn:
      'https://c67431ff70d6440fb529c2705792425f@o176457.ingest.sentry.io/1723141',
    environment: config.mode,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    ignoreErrors: ignoredErrorStrings,
    beforeSend(event, hint) {
      if (isInvalidError(hint, event)) {
        return null
      }

      if (hint?.originalException?.name === 'FirebaseError') {
        if (event.exception?.values?.[0]?.mechanism?.handled === false) {
          return event
        } else {
          console.log('Firebase Exception handled: skipped in sentry logs')
          return null
        }
      }

      return event
    },
    sampleRate: 1, // for errors
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
    logErrors: true,
    trackComponents: true,
  })
}
